module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch4_20210921105334_T.3ea08321.jpg";